(() => {
  const root = document.querySelector('.om-home');
  if (!root) return;
  const seen = new WeakSet();
  const inspect = image => {
    const url = new URL(image.currentSrc || image.src, location.href);
    url.searchParams.set('width', '64');
    const sample = new Image();
    sample.crossOrigin = 'anonymous';
    sample.onload = () => {
      try {
        const canvas = document.createElement('canvas');
        canvas.width = canvas.height = 32;
        const context = canvas.getContext('2d', {willReadFrequently: true});
        if (!context) return;
        context.fillStyle = '#fff';
        context.fillRect(0, 0, 32, 32);
        context.drawImage(sample, 0, 0, 32, 32);
        const pixels = context.getImageData(0, 0, 32, 32).data;
        let light = 0, total = 0;
        for (let y = 0; y < 32; y++) for (let x = 0; x < 32; x++) {
          if (x > 2 && x < 29 && y > 2 && y < 29) continue;
          const i = (y * 32 + x) * 4;
          const r = pixels[i], g = pixels[i + 1], b = pixels[i + 2];
          total++;
          if (Math.min(r, g, b) >= 238 && Math.max(r, g, b) - Math.min(r, g, b) <= 12) light++;
        }
        image.closest('.om-card-image,.om-lead-image')?.classList.toggle('om-photo-edge', light / total >= .84);
      } catch (_) {}
    };
    sample.src = url.href;
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      const image = entry.target;
      if (image.complete && image.naturalWidth) inspect(image);
      else image.addEventListener('load', () => inspect(image), {once: true});
    });
  }, {rootMargin: '150px'}) : null;
  const scan = () => root.querySelectorAll('.om-card-image img,.om-lead-image img').forEach(image => {
    if (seen.has(image)) return;
    seen.add(image);
    if (observer) observer.observe(image);
    else if (image.complete && image.naturalWidth) inspect(image);
    else image.addEventListener('load', () => inspect(image), {once: true});
  });
  scan();
  const changes = new MutationObserver(scan);
  changes.observe(root.querySelector('[data-om-grid]') || root, {childList: true, subtree: true});
  window.addEventListener('pagehide', () => {observer?.disconnect(); changes.disconnect();}, {once: true});
})();